import React from 'react';
import { FaUserShield } from 'react-icons/fa';
import { Card } from '../components/ds/core/Card';
import { Badge } from '../components/ds/core/Badge';
import './AboutView.css';

const cardStyle = {
  background: '#e6e7eb',
  color: 'var(--text-body)',
  border: '1px solid var(--border-subtle)',
  boxShadow: 'var(--shadow-md)',
  backdropFilter: 'none',
};

function PrivacyView() {
  return (
    <div className="about-view">
      <div className="about-container">
        <div className="about-header">
          <Badge tone="brand" icon={<FaUserShield />}>Privacy Policy</Badge>
          <h1>Your privacy on Yapp</h1>
          <p>Last updated: June 23, 2026</p>
        </div>

        <div className="about-content">
          <Card variant="glass" padding="lg" className="about-section about-intro" style={cardStyle}>
            <h2>The short version</h2>
            <p>
              Yapp lets you send messages to people around the world. We only collect what we
              need to run the service, we never sell your data, and your email and date of birth
              are kept private — other users can never see them.
            </p>
          </Card>

          <Card variant="glass" padding="lg" className="about-section" style={cardStyle}>
            <h2>Information we collect</h2>
            <p>
              <strong>Account details:</strong> your email address and date of birth (used only to
              verify you are 18 or older). These are stored privately and are never shown to other users.
            </p>
            <p>
              <strong>Profile:</strong> your chosen username, approximate country (detected from your
              IP address at sign-in), theme preferences, and premium status.
            </p>
            <p>
              <strong>Activity:</strong> the messages you send and receive, your friends and blocked
              users, and reports you submit.
            </p>
          </Card>

          <Card variant="glass" padding="lg" className="about-section" style={cardStyle}>
            <h2>How we use your information</h2>
            <p>
              To provide and operate the service, deliver your messages, verify your age, keep the
              community safe (moderation and abuse reports), and process premium purchases. We do not
              use your data for advertising and we do not sell it.
            </p>
          </Card>

          <Card variant="glass" padding="lg" className="about-section" style={cardStyle}>
            <h2>Service providers we use</h2>
            <p>
              <strong>Google Firebase</strong> — hosting, authentication, and database. Your data is
              stored on Google's secure infrastructure.
            </p>
            <p>
              <strong>PayPal</strong> — processes premium payments. We never see or store your card
              details; PayPal handles payment information directly.
            </p>
            <p>
              <strong>ipapi.co</strong> — used once at sign-in to estimate your country from your IP address.
            </p>
          </Card>

          <Card variant="glass" padding="lg" className="about-section" style={cardStyle}>
            <h2>Advertising</h2>
            <p>
              Yapp may display ads through <strong>Google AdSense</strong>. Google and its partners
              use cookies to serve ads based on your prior visits to this and other websites. You can
              opt out of personalized advertising in your{' '}
              <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">Google Ad Settings</a>,
              and learn more at{' '}
              <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">Google's advertising policies</a>.
              Premium members do not see ads.
            </p>
          </Card>

          <Card variant="glass" padding="lg" className="about-section" style={cardStyle}>
            <h2>How we protect your data</h2>
            <p>
              Access to your data is controlled by security rules so that only you (and our moderation
              staff, where necessary for safety) can read your private information. Requests to our
              backend are verified with App Check, and all traffic is encrypted over HTTPS.
            </p>
          </Card>

          <Card variant="glass" padding="lg" className="about-section" style={cardStyle}>
            <h2>Your choices</h2>
            <p>
              You can update your profile at any time from the Profile page. You can delete your
              account, which removes your profile and associated data. If you need help accessing or
              deleting your data, reach out through the Support page.
            </p>
          </Card>

          <Card variant="glass" padding="lg" className="about-section" style={cardStyle}>
            <h2>Children</h2>
            <p>
              Yapp is intended for users aged 18 and older. We do not knowingly collect information
              from anyone under 18, and accounts are age-gated at sign-up.
            </p>
          </Card>

          <Card variant="glass" padding="lg" className="about-section" style={cardStyle}>
            <h2>Data retention</h2>
            <p>
              We keep your information for as long as your account is active. When you delete your
              account, your associated data is removed.
            </p>
          </Card>

          <Card variant="glass" padding="lg" className="about-section" style={cardStyle}>
            <h2>Changes to this policy</h2>
            <p>
              We may update this policy from time to time. When we do, we'll revise the "last updated"
              date at the top of this page.
            </p>
          </Card>

          <Card variant="glass" padding="lg" className="about-section" style={cardStyle}>
            <h2>Contact</h2>
            <p>
              Questions about your privacy? Visit the Support page and we'll help you out.
            </p>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default PrivacyView;
